<template>
    <div id="btm">
      <span title="展开" v-show="isShowBtm===false" @click="hideBtm">▲</span>
      <textarea id="inText" ref="inText" v-show="isShowBtm"></textarea>
      <span id="btmOp" v-show="isShowBtm">
        <span title="隐藏" @click="hideBtm">▼</span>
        <span>提交者<input id="author" ref="author" value="public"></span>
        <span><button id="btnSubmit" @click="selectFile" >提交图片</button>
              <input type="file" ref="file" style="display:none;" @change="fileChange">
        </span>
        <span><button id="btnSubmit" @click="submit">提交文本</button></span>
      </span>
    </div>
</template>

<script>
import axios from 'axios'
axios.defaults.withCredentials = true

export default {
  name: 'btmBar',
  data () {
    return {
      isShowBtm: true
    }
  },
  created () {
    var clientHeight = document.documentElement.clientHeight || document.body.clientHeight
    window.onresize = function () {
      var nowClientHeight = document.documentElement.clientHeight || document.body.clientHeight
      if (clientHeight - nowClientHeight > 60) { // 因为ios有自带的底部高度
        // 键盘弹出的事件处理
        document.getElementById('inText').classList.add('focusState')
      } else {
        // 键盘收起的事件处理
        document.getElementById('inText').classList.remove('focusState')
      }
    }
  },
  methods: {
    hideBtm: function () {
      this.isShowBtm = !this.isShowBtm
    },
    submit: function () {
      if (this.$refs.inText.value.length === 0 ||
          this.$refs.author.value.length === 0) {
        alert('不能为空\n')
        return
      }
      let data = {msg: this.$refs.inText.value, author: this.$refs.author.value}
      axios.post('/submit', data)
        .then(res => {
          if (res.data === 'ok') {
            this.$refs.inText.value = ''
          }
        }).catch(err => {
          alert('服务器上传异常')
          console.log(err)
        })
    },
    selectFile: function () {
      this.$refs.file.click()
    },
    fileChange: function (e) {
      if (this.$refs.author.value.length === 0) {
        alert('提交者不能为空\n')
        return
      }
      // 通过DOM取文件数据
      const file = this.$refs.file.files[0]
      if (file.type !== 'image/jpeg' &&
          file.type !== 'image/png') {
        alert('请提交jpg、png类型的图片')
        return
      }
      // 生成随机名
      let fname = new Date().toLocaleDateString() +
                  '-' + parseInt(Math.random() * 8999 + 10000) +
                  '-' + file.name
      // 计算文件大小 KB
      // const size = Math.floor(file.size / 1024)
      // 使用 FormData 构建表单数据
      const formData = new FormData()
      formData.append('file', file, fname)
      console.log(formData.file)
      formData.append('author', this.$refs.author.value)
      axios.post('/submitFile', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        console.log('res:' + res.data)
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style>
#btm{
  position: fixed;
  bottom: 0px;
  width:99%;
  background:#BDBDBD;
  z-index:10;
}
#inText{
  font-size:15px;
  width:99%;
  margin:2px;
}
#btmOp{
  width: 100%;
  background:#BDBDBD;
}
#btm span:first-child:hover{
  background:#000;
}
#btm span{
  display: inline-block;
  margin-right: 10px;
  float: left;
}
#btm input{
  width: 50%;
}
.focusState{
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/btmBar.vue